module.exports = require("@material-ui/core/ListItemIcon");